import LocaleCode from "../domain/LocaleCode.js"
import type { DisplayText } from "./dto/DisplayText.js"
import enUS from "./en-US.js"
import esAR from "./es-AR.js"
import esCL from "./es-CL.js"
import esCO from "./es-CO.js"
import esEC from "./es-EC.js"
import esPA from "./es-PA.js"
import esPE from "./es-PE.js"

/**
 * @description
 *	All translations available for the entire application.
 *
 * @see https://ui.docs.amplify.aws/react/connected-components/liveness/customization#internationalization-i18n
 * @see https://github.com/aws-amplify/amplify-ui/blob/main/packages/react-liveness/src/components/FaceLivenessDetector/displayText.ts
 */
const Translation: Record<LocaleCode, DisplayText> = {
	[LocaleCode.en_US]: enUS,
	[LocaleCode.es_AR]: esAR,
	[LocaleCode.es_CL]: esCL,
	[LocaleCode.es_CO]: esCO,
	[LocaleCode.es_EC]: esEC,
	[LocaleCode.es_PA]: esPA,
	[LocaleCode.es_PE]: esPE
}

export default Translation
